import i18n from './../i18n'

export const dateUtils = {
    methods: {
        formatDate: (longDate) => {
            return new Date(longDate).toLocaleDateString('fr-FR') + " " + i18n.t('à') + " " + new Date(longDate).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})
        }  ,
        formatDateSimple: (longDate) => {
            return new Date(longDate).toLocaleDateString('fr-FR') + " " + new Date(longDate).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/utils.js